import { render } from "./page-not-found.vue?vue&type=template&id=7506b42c&scoped=true"
const script = {}

import "./page-not-found.vue?vue&type=style&index=0&id=7506b42c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7506b42c"]])

export default __exports__